import { apiRequest } from "@services/apiClient";
import homeContentFaqsEndpoints from "@services/homeContent/homeContentFaqsEndpoints";

function normalizeFaqsFromBody(body) {
  if (Array.isArray(body?.faqs)) return body.faqs;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body)) return body;
  return [];
}

export async function listHomeContentFaqsRequest() {
  const response = await apiRequest(homeContentFaqsEndpoints.base);
  return {
    ...response,
    body: normalizeFaqsFromBody(response?.body),
  };
}

export async function createHomeContentFaqsRequest(payload) {
  const response = await apiRequest(homeContentFaqsEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeFaqsFromBody(response?.body),
  };
}

export async function updateHomeContentFaqsRequest(payload) {
  const response = await apiRequest(homeContentFaqsEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeFaqsFromBody(response?.body),
  };
}

export async function saveHomeContentFaqsRequest(payload) {
  try {
    return await updateHomeContentFaqsRequest(payload);
  } catch (error) {
    if (Number(error?.status) === 404) {
      return createHomeContentFaqsRequest(payload);
    }
    throw error;
  }
}

export function deleteHomeContentFaqRequest(id) {
  return apiRequest(homeContentFaqsEndpoints.byId(id), {
    method: "DELETE",
  });
}
